import Button, { ButtonSizes, ButtonVariants } from '@gym-atoms/Button/Button';
import DialogBox, { DialogBoxVariants } from '@gym-atoms/Dialog/DialogBox';
import Loader from '@gym-atoms/Loader/Loader';
import Table, { TableProps } from '@gym-molecules/Table/Table';
import Text from '@gym-atoms/Text/Text';
import { deleteAccessCategory, fetchAccessCategories } from '@gym-redux/slices/accessCategorySlice';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API } from 'aws-amplify';
import { isAccessCategoryLinked } from '@gym-graphql/queries';
import { CountResponse } from '@gym-src/API';
import { useHistory } from 'react-router-dom';
import { GymChainAccessCategoryTable } from '../../../particles/types/GymChainAccessCategory';
import { GymAccessCategoryType } from '../../../particles/types/AccessCategoryMapping';

const AccessCategoryMappingList = (props: AccessCategoryMappingListProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);
  const [
    selectedAccessCategoryRow,
    setSelectedAccessCategoryRow
  ] = useState<GymChainAccessCategoryTable>();
  const [accessCategorySortField, setAccessCategorySortField] = useState('id');
  const [accessCategorySortOrder, setAccessCategorySortOrder] = useState(-1);
  const [accessCategoryOffset, setAccessCategoryOffset] = useState(0);
  const [accessCategoryPageSize, setAccessCategoryPageSize] = useState(10);
  const isAccessCategoryLoading = useAppSelector(
    (state) => state.accessCategory.isAccessCategoriesLoading
  );
  const [accessCategorySearchTerm, setAccessCategorySearchTerm] = useState('');
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [accessCategoryDeletableCheckLoading, setAccessCategoryDeletableCheckLoading] = useState(
    false
  );
  const [isDeleting, setIsDeleting] = useState(false);
  const [accessCategoryDeletableStatus, setAccessCategoryDeletableStatus] = useState(false);
  const userRole = useAppSelector((state) => state.user.userRole);
  const totalAccessCategoryCount =
    useAppSelector(
      (state) =>
        state.accessCategory.items.find((g) => g.siteLocationId === props.gymId)?.totalRecords
    ) || 0;

  useEffect(() => {
    dispatch(
      fetchAccessCategories({
        siteLocationId: props.gymId
      })
    );
  }, [props.gymId]);

  useEffect(() => {
    console.log({ selectedAccessCategoryRow });
  }, [selectedAccessCategoryRow]);

  const mapAccessCategories = (accessCategories?: GymAccessCategoryType[]) => {
    if (!accessCategories) {
      return;
    }
    const mappedAccessCategories: GymChainAccessCategoryTable[] = [];

    accessCategories.forEach((accessCategory) => {
      const index = mappedAccessCategories.findIndex((mappedAccessCategory) => {
        return (
          mappedAccessCategory.name === accessCategory.name &&
          +mappedAccessCategory.age === +accessCategory.age &&
          mappedAccessCategory.gender === accessCategory.gender
        );
      });

      if (index > -1) {
        mappedAccessCategories[index].accessCategoryDetails.push({
          siteLocationAccessCategoryId: accessCategory.siteLocationAccessCategoryId,
          siteLocationId: accessCategory.siteLocationId,
          siteLocationMembershipId: accessCategory.siteLocationMembershipId,
          accessCategoryId: accessCategory.accessCategoryId,
          locationName: accessCategory.locationName,
          arxAccessCategoryId: accessCategory.arxAccessCategoryId,
          membershipName: accessCategory.membershipName,
          membershipImportedId: accessCategory.importedId,
          program: accessCategory.program,
          scheduleType: accessCategory.scheduleType
        });
      } else {
        mappedAccessCategories.push({
          id: accessCategory.id,
          siteId: accessCategory.siteId,
          name: accessCategory.name,
          gender: accessCategory.gender,
          age: accessCategory.age > 0 ? accessCategory.age : null,
          schedulesOnly: accessCategory.schedulesOnly,
          status: accessCategory.status,
          accessCategoryDetails: [
            {
              siteLocationAccessCategoryId: accessCategory.siteLocationAccessCategoryId,
              siteLocationId: accessCategory.siteLocationId,
              siteLocationMembershipId: accessCategory.siteLocationMembershipId,
              accessCategoryId: accessCategory.accessCategoryId,
              locationName: accessCategory.locationName,
              arxAccessCategoryId: accessCategory.arxAccessCategoryId,
              membershipImportedId: accessCategory.importedId,
              membershipName: accessCategory.membershipName,
              program: accessCategory.program,
              scheduleType: accessCategory.scheduleType
            }
          ]
        });
      }
    });

    console.log({ mappedAccessCategories });
    return mappedAccessCategories;
  };

  console.log(props);
  const gymAccessCategories = useAppSelector((state) => {
    console.log(state.accessCategory);
    return mapAccessCategories(
      state.accessCategory.items.find((e) => e.siteLocationId === props.gymId)?.items
    );
  });

  const menuItem = [
    {
      label: t('COMMON.MODIFY'),
      command: () => {
        console.log('here');
        history.push(
          `/gymChains/${props.chainId}/gyms/${props.gymId}/gymAccessCategories/${selectedAccessCategoryRow?.id}`
        );
      }
    },
    {
      label: t('COMMON.DELETE'),
      command: () => {
        checkAccessCategoryDeletable();
      }
    }
  ];

  const checkAccessCategoryDeletable = async () => {
    setIsDeleteDialogVisible(true);
    setAccessCategoryDeletableCheckLoading(true);
    try {
      const response = await (API.graphql({
        query: isAccessCategoryLinked,
        variables: {
          locationAccessCategoryId: selectedAccessCategoryRow?.id
        }
      }) as Promise<{
        data: { isAccessCategoryLinked: CountResponse };
      }>);
      if (
        response.data.isAccessCategoryLinked.count !== undefined &&
        response.data.isAccessCategoryLinked.count !== null
      ) {
        response.data.isAccessCategoryLinked.count > 0
          ? setAccessCategoryDeletableStatus(false)
          : setAccessCategoryDeletableStatus(true);
      } else {
        console.log('Error Delete Validation Query');
        setErrorDialogVisible(true);
      }
      setAccessCategoryDeletableCheckLoading(false);
    } catch (error) {
      setErrorDialogVisible(true);
      setIsDeleteDialogVisible(false);
      console.log('Catch: ', error);
      setAccessCategoryDeletableStatus(false);
      setAccessCategoryDeletableCheckLoading(false);
    }
  };

  const tablePropsAccessCategory: TableProps<GymChainAccessCategoryTable> = {
    exportFileName: t('ACCESS_CATEGORY.EXPORT_EXCEL_FILE_NAME'),
    setPageSize: setAccessCategoryPageSize,
    setOffset: setAccessCategoryOffset,
    pageSize: accessCategoryPageSize,
    offset: accessCategoryOffset,
    setSortField: setAccessCategorySortField,
    setSortOrder: setAccessCategorySortOrder,
    sortField: accessCategorySortField,
    sortOrder: accessCategorySortOrder,
    totalRecords: totalAccessCategoryCount,
    uniqueFieldName: 'id',
    data: gymAccessCategories || undefined,
    searchTerm: accessCategorySearchTerm,
    setSearchTerm: setAccessCategorySearchTerm,
    emptyStateTexts: [t('ACCESS_CATEGORY.EMPTY_STATE_TEXT')],
    columns: [
      {
        field: 'name',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_NAME'),
        toggable: false,
        sortable: true,
        truncateText: true
      },
      {
        field: 'gender',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_GENDER'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'age',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_AGE'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'schedulesOnly',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_SCHEDULES_ONLY'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'status',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_STATUS'),
        toggable: true,
        truncateText: true
      }
    ],
    isContextMenu: true,
    menuItem: menuItem,
    lazy: false,
    expandable: true,
    expandableField: 'accessCategoryDetails',
    expandedCols: [
      {
        field: 'locationName',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_LOCATION_NAME'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'arxAccessCategoryId',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_ARX_ID'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'membershipImportedId',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_MEMBERSHIP_IMPORTED_ID'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'siteLocationMembershipId',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_LOCATION_MEMBERSHIP_ID'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'membershipName',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_MEMBERSHIP_NAME'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'program',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_PROGRAM'),
        toggable: true,
        truncateText: true
      },
      {
        field: 'scheduleType',
        header: t('GYM_ACCESS_CATEGORY.TABLE.HEADER_ACCESS_CATEGORY_SCHEDULE_TYPE'),
        toggable: true,
        truncateText: true
      }
    ],
    headerBtns: [
      <div className="d-flex" key={1}>
        <Button
          label={t('GYM_ACCESS_CATEGORY.ADD_NEW_ACCESS_CATEGORY_BUTTON_LABEL')}
          size={ButtonSizes.small}
          onClick={() =>
            history.push(`/gymChains/${props.chainId}/gyms/${props.gymId}/gymAccessCategories/new`)
          }
        />
      </div>
    ],
    searchPlaceholderText: t('ACCESS_CATEGORY.SEARCH_FIELD_TEXT'),
    excelBtntext: t('ACCESS_CATEGORY.EXPORT_EXCEL_BUTTON_LABEL'),
    selectedRow: selectedAccessCategoryRow,
    setSelectedRow: setSelectedAccessCategoryRow
  };

  const deleteDialogHandler = async () => {
    setIsDeleting(true);
    selectedAccessCategoryRow &&
      selectedAccessCategoryRow.accessCategoryDetails.forEach(async (accessDetailsRow) => {
        console.log(accessDetailsRow);
        await dispatch(deleteAccessCategory(accessDetailsRow?.siteLocationAccessCategoryId));
      });
    setIsDeleting(false);
    setIsDeleteDialogVisible(false);
  };

  const DeleteDialogFooter = () => {
    return (
      <div>
        {accessCategoryDeletableCheckLoading ? (
          <></>
        ) : !accessCategoryDeletableStatus ? (
          <Button
            label={t('COMMON.OK')}
            variant={ButtonVariants.basic}
            onClick={() => setIsDeleteDialogVisible(false)}
          />
        ) : (
          <>
            <Button
              label={t('COMMON.CANCEL')}
              variant={ButtonVariants.textonly}
              onClick={() => setIsDeleteDialogVisible(false)}
            />
            <Button
              label={t('COMMON.DELETE')}
              variant={ButtonVariants.danger}
              onClick={deleteDialogHandler}
              icon={isDeleting ? 'pi-spinner pi-spin' : ''}
            />
          </>
        )}
      </div>
    );
  };

  const ErrorDialogFooter = () => {
    return (
      <div>
        <Button
          label={t('COMMON.OK')}
          variant={ButtonVariants.textonly}
          onClick={() => setErrorDialogVisible(false)}
        />
      </div>
    );
  };

  return (
    <>
      <DialogBox
        dialogVisible={isDeleteDialogVisible}
        variant={DialogBoxVariants.long}
        dialogDismissableMask={true}
        onHideCallback={() => setIsDeleteDialogVisible(false)}
        dialogFooter={<DeleteDialogFooter />}
        dialogClosable={false}
        dialogHeader={t('COMMON.DELETE')}
        content={
          accessCategoryDeletableCheckLoading ? (
            <>
              <div className="mb-3">
                <Loader shape="rectangle" width="full" />
              </div>
              <div className="mb-3">
                <Loader shape="rectangle" width="full" />
              </div>
              <div className="mb-3">
                <Loader shape="rectangle" width="half" />
              </div>
            </>
          ) : (
            <Text>
              {accessCategoryDeletableStatus
                ? `${t('ACCESS_CATEGORY.DELETE_MODAL_CONFIRM')} ${selectedAccessCategoryRow?.name}?`
                : t('ACCESS_CATEGORY.DELETE_MODAL_CANNOT')}
            </Text>
          )
        }
      />
      <DialogBox
        dialogVisible={errorDialogVisible}
        variant={DialogBoxVariants.long}
        dialogDismissableMask={true}
        onHideCallback={() => setErrorDialogVisible(false)}
        dialogFooter={<ErrorDialogFooter />}
        dialogClosable={false}
        dialogHeader={t('ACCESS_CATEGORY.ERROR_HEADER')}
        content={<Text>{t('ACCESS_CATEGORY.ERROR_MESSAGE')}</Text>}
      />
      {isAccessCategoryLoading ? <Loader shape="table" /> : <Table {...tablePropsAccessCategory} />}
    </>
  );
};

export interface AccessCategoryMappingListProps {
  gymId: number;
  chainId: number;
  heading?: string;
}

export default AccessCategoryMappingList;
